<template>
    <div
        v-if="displayLocationName"
        class="location-name"
        :class="{ clickable: hasLocationAddress }"
        @click="onLocationNameClick"
    >
        {{ locationName }}
    </div>
</template>

<script setup lang="ts">
    import { LocationAddressPopup } from "@/app/ui/LocationAddressPopup";
    import { ConsumptionSiteDisplayMode } from "@/data/model/Enums";
    import type { IOrderApplication } from "@/data/model/OrderApplication";
    import type { ITableAllocation } from "@/data/model/Table";
    import { computed, ref } from "vue";

    const props = defineProps<{
        useCase: IOrderApplication | undefined;
        allocation: ITableAllocation | undefined;
    }>();

    const locationName = ref(props.allocation?.locationName);
    const displayLocationName = computed(
        () => props.useCase?.consumptionSiteDisplayMode === ConsumptionSiteDisplayMode.LocationAddress
    );
    const hasLocationAddress = computed(() => props.allocation?.locationAddress != null);

    function onLocationNameClick() {
        const allocation = props.allocation;
        const locationAddress = allocation?.locationAddress;
        const googleMapsLocationLink = allocation?.googleMapsLocationLink;

        if (locationAddress) {
            LocationAddressPopup.show(locationAddress, googleMapsLocationLink);
        }
    }
</script>

<style lang="scss">
    .order-received-popover-content .location-name {
        color: var(--colorPrimary);
        margin-top: 6px;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        text-decoration: underline;

        &.clickable {
            cursor: pointer;
        }
    }
</style>
